/**
 * Las dos pestañas del tablero. BOTONES y no <a>: la navegación entera vive en el
 * query string vía pushState (useQueryState), y un anchor necesitaría un
 * preventDefault para no recargar la página — acá no hay ningún href real al que ir.
 */
export type DashboardView = "people" | "requests"

const TABS: { id: DashboardView; label: string }[] = [
  { id: "people", label: "Por persona" },
  { id: "requests", label: "Solicitudes" },
]

export function ViewTabs({
  view,
  onChange,
}: {
  view: DashboardView
  onChange: (v: DashboardView) => void
}) {
  return (
    <nav className="view-tabs" aria-label="Vistas del tablero">
      {TABS.map((t) => (
        <button
          key={t.id}
          type="button"
          className={`view-tab${view === t.id ? " is-active" : ""}`}
          aria-current={view === t.id ? "page" : undefined}
          onClick={() => onChange(t.id)}
        >
          {t.label}
        </button>
      ))}
    </nav>
  )
}
